import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	InformationContainer,
	GridInformationData,
	Computer,
	ContainerSpider
} from './styles';
import { Grid, Typography, Box } from '@material-ui/core';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { useTranslation } from 'react-i18next';
import Animation from '../../../../components/Animation';
import { scrollToInformationSelector } from '../../selectors';

const Information = props => {
	const ref = useRef(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (props.scrollToInformation) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToInformation]);

	return (
		<InformationContainer ref={ref}>
			<Computer />
			<ContainerSpider />
			<Grid container>
				<GridInformationData item xs={12} sm={6}>
					<Animation animateIn="fadeInLeft">
						<LabelTitle content={t('general.information.label')} />
						<Typography variant="h2" color="textSecondary">
							{t('general.information.title')}
						</Typography>
					</Animation>
					<Animation animateIn="fadeIn" duration={2}>
						<Box mt={3}>
							<Typography variant="body1" className="paragraph-dark">
								{t('general.information.paragraphMain')}
							</Typography>
							<Typography variant="body1" color="textPrimary" paragraph>
								{t('general.information.paragraphFirst')}
							</Typography>
							<Typography variant="body1" color="textPrimary" paragraph>
								{t('general.information.paragraphSecond')}
							</Typography>
						</Box>
					</Animation>
				</GridInformationData>
			</Grid>
		</InformationContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToInformation: scrollToInformationSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Information);
